export const supportedLanguages = [
  { label: "English", code: "en" },
  { label: "German", code: "de" },
] as const;

export const defaultLanguage = "en" as const;

export type SupportedLanguage = (typeof supportedLanguages)[number]["code"];
